/**
 * @generated SignedSource<<95c9585dd277e123e97b2c48fcfccf48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveBankTransactionRuleInput = {
  id: string;
};
export type DeleteBankTransactionRuleDialogMutation$variables = {
  input: RemoveBankTransactionRuleInput;
};
export type DeleteBankTransactionRuleDialogMutation$data = {
  readonly removeBankTransactionRule: {
    readonly id: string;
  };
};
export type DeleteBankTransactionRuleDialogMutation = {
  response: DeleteBankTransactionRuleDialogMutation$data;
  variables: DeleteBankTransactionRuleDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "removeBankTransactionRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteBankTransactionRuleDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteBankTransactionRuleDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b9abbeb2253c7158ea0c735991de0d4",
    "id": null,
    "metadata": {},
    "name": "DeleteBankTransactionRuleDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteBankTransactionRuleDialogMutation(\n  $input: RemoveBankTransactionRuleInput!\n) {\n  removeBankTransactionRule(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c5561d958ed78e695069f77b458c0bfb";

export default node;
